import { IconBook, IconHome, IconMessageCircle } from "@tabler/icons-react";
export const RouteList = [
  {
    path: "/d/overview",
    label: "Overview",
    icon: IconHome,
  },

  {
    path: "/d/courses",
    label: "Courses",
    icon: IconBook,
  },
];
